<template>
  <div>
    <div class="invest_area">
      <div class="invest_area_top">
        <div class="invest_area_top_icon">
          <img @click="$router.back()" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAABj0lEQVRYR+2YrU4EMRSFvxMSNJKXwYIBh8LheAHAEBLcwgPgSAgCBVnBA2DAYDC8BIKENRBAXNJklnTLdCeI2d6SHTc/ab85c9o594rKDlXGyxy47y82V9ilwma2CFwAm8BA0kHfoOPx/2yJBvYK2GgGGUlacgncAhs4zyVtuwM2swVgGCkbGG+CLSR9ugJuYINntyKwmcOGuTs97Am2EzgDewusS3qblQ3iebIKm1m4dwbEC6oobFbhBvYU2InerjhsK3AG9g5YK2WDrCUysA/AqqRRCc+mc0542MxOgN3oIVewE5YwswGw7xn2B7gF9glYkfTqwQYTHjazI+AwuvgCXAPvhWG/gEtJjynwBxDiosfjWdJy9cB1WSLIXdWiG/ujqm0tgj4G9jzvxemfLpynocfV3+5XvMzkifsmTxTJwJ15uKp4Gfm5ngAfQYdKOS0+iwb5/1WEdijts8xPoOtopETQIdXFfbVwy2eragq032ZgAl1Hu7V0yu/c1koDTi3zvcG18cwV7vsrVafwN+j4vi3HfpsqAAAAAElFTkSuQmCC" alt="">
          <img @click="$router.push({name: 'Mhome'})" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAB6ElEQVRIS+WVT4iOURTGf48mNRsbSikWyEaUhWGjoSwoVpIkBhuFspEoimzEShll5V+SsBrFQjHNxp+FIhtiYUopLGyU5NGj+07vvPN9M998ysZd3nvO757z3HPuEVMs273AWWBXMb0GHJH0fTJXTXZoexFwF1gG3Ci2O4BXwBZJ79r5twXb3gwkOidaSfcCsb2p7Mc3+0Ot4BPAtmcAp4GjwMsS2fu6s+2FJZPlwBnghKRfdZtxYNtzgJvAeuAKsL+dlkX7i8Bu4CGwXdLnCj4Gtt0H3AbmAockXZrqYYs0+4DzwCdgq6Rn2f8Dtt0PPKgdPu8EWtnYXlkLaoOk4QqcW2YDq+rpTBMeGZ8CXyT1VeCfwDlJx6YDa9razkMeltRTgVNSJyWd+ktwqum4sorG/x5se02qBJhXsvmYKpA00kKKziK2nXq+D6Q+XxfQUiAPtVFS6nds2e4Y/BiYD6yQ9K3INgt4AYxKWtst+APwSNJAA3AVWCdpQbfg0bSrpD0NwOW0vaRk05UU/yE4Y+YOsLd87NEtf8db4LqkAw0tB4GdwGLgazlLs0X7TJbeqvMuAOOci/EPoF/SkwZ4NTAMzGzxBQxKOliBMzW2AUtqhvmYhiRlikxYtjM9Mr56aodvgFuZJr8B7K4cJgApFdwAAAAASUVORK5CYII=" alt="">
        </div>
        <span>{{ $t('pay.account') }}</span>
      </div>
      <div class="invest_num">
        <span class="num">{{balance}}</span>
        <span class="num_txt">{{ $t('pay.remaining_quantity') }}</span>
      </div>
    </div>
    <div class="invest_content">
      <div class="invest_content_title">
        <div>
        </div>
        <span>{{ $t('pay.select_recharge_type') }}</span>
        <div>
        </div>
      </div>
      <div class="invest_list">
        <div
            class="invest_item"
            :class="currentIndex == 0 ? 'invest_item_choose': ''"
            @click="currentIndex = 0;total_price = cus_input"
        >
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAADa0lEQVRIS8WXT2xUVRTGf9+TlkoNRSom2g2JQRNNcIENM1NCbDQl1c5UNOoOogbDSomsYOVKV2JITGyMTqKs1fAYwDYqJoTOFG0XhmAaJC4aUAOVoBb6Z+YdM29m2r46zH0lFe/yvXO+755zz/nuuSLGslNPtrC6rRdZD7AF7CFQW8XVroMuAqOYhpi5flLd3027YNXIwL5+qp17Wvdj7AXudYFV/19DDPD31Ht6+pvJW/nckthG+ncR2CGgPSbhUrNJPL2lrUc/q+f/L2L7YUsTxY4BjFdvkzDqJrKsurRXT4zOLf4RIQ5J5x78HJReEdJ5EDtG0+UXFpNHiQuZT1Ys0qU7F1kl/Ndqn+eJq2f6afxIg24CmvG8wdg+nnbXzjwkDqu3tXU8diGJq0r4G+zci838NTMB3B+TfJKpqUfK1V4hLmTewTjgdrYxvGCfth4/vdjWzqQ78TgE2ubEsOBdpXIHFYpDy9rL7j61n/hzplM7hqbqgVej/xbocpBf4765B2TD/TuRfeHcKcEeJXMfhxnKZ7rA3gfNQvCGkrmx8PtwfwrZGSeW6XlZPvMhhMrUeJVK27WtkmLLp7OgV0IHMYEFB8DrwtiOeMwFhTFQJj4LdLqNLa3UsVylJvp6MO/IMopqKfz3snx6ErTeTcxhpfx9NbuK2HT0Arsx+hF3OTEWBOWPcsRFiOU0C7zOoH9EbxNEqrrQtwnTYVB5I+5llGTDmeKydivGMbIo+FKJ3IXIBvKZj4A9TuaQOG6q6/YQ44iDSvphV1ihdy3W9CuwpjG5hamOV1xwA1HA7Aro5QVgK2K2UancpQp5Jo+RcERdLq5Y7XSRiZ8f1UvnZ22wp5W2ljGMhyvgNo20UQn/92qrnQU17pKwneIJiBGUNqvr+LkQ/NRz62ixXWDrIfAXBKSvA3m/AE0NIw4FJLZk8iPTxR3qPvFb3eMe2dlOqeQjUo40VySzei4xLwmuAh+AvlLy6Ejoe7rvcVbpWdCbsQSldkmEzsu9FstKmfRr2brpbJ8Fg+i1GJJXhrs7OwjMy+B/OfoYWaXqjD5h1P/XsDdPvpLjbVlemx3jbUR37/RAHyEvV/uau/cjb3lPGAsGuHHz9p4wkQ1c6F3NleZnwHpQ9dFm1Uebqo82YxQ0xIbZE9p0csbVYv8AnmGHerVutGQAAAAASUVORK5CYII=" alt="">
          <input class="input"  v-model="cus_input" @change="total_price = cus_input">
        </div>
        <div
            class="invest_item"
            v-for="item in list"
            :key="item.id"
            :class="currentIndex == item.id ? 'invest_item_choose': ''"
            @click="select(item)"
        >
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAADa0lEQVRIS8WXT2xUVRTGf9+TlkoNRSom2g2JQRNNcIENM1NCbDQl1c5UNOoOogbDSomsYOVKV2JITGyMTqKs1fAYwDYqJoTOFG0XhmAaJC4aUAOVoBb6Z+YdM29m2r46zH0lFe/yvXO+755zz/nuuSLGslNPtrC6rRdZD7AF7CFQW8XVroMuAqOYhpi5flLd3027YNXIwL5+qp17Wvdj7AXudYFV/19DDPD31Ht6+pvJW/nckthG+ncR2CGgPSbhUrNJPL2lrUc/q+f/L2L7YUsTxY4BjFdvkzDqJrKsurRXT4zOLf4RIQ5J5x78HJReEdJ5EDtG0+UXFpNHiQuZT1Ys0qU7F1kl/Ndqn+eJq2f6afxIg24CmvG8wdg+nnbXzjwkDqu3tXU8diGJq0r4G+zci838NTMB3B+TfJKpqUfK1V4hLmTewTjgdrYxvGCfth4/vdjWzqQ78TgE2ubEsOBdpXIHFYpDy9rL7j61n/hzplM7hqbqgVej/xbocpBf4765B2TD/TuRfeHcKcEeJXMfhxnKZ7rA3gfNQvCGkrmx8PtwfwrZGSeW6XlZPvMhhMrUeJVK27WtkmLLp7OgV0IHMYEFB8DrwtiOeMwFhTFQJj4LdLqNLa3UsVylJvp6MO/IMopqKfz3snx6ErTeTcxhpfx9NbuK2HT0Arsx+hF3OTEWBOWPcsRFiOU0C7zOoH9EbxNEqrrQtwnTYVB5I+5llGTDmeKydivGMbIo+FKJ3IXIBvKZj4A9TuaQOG6q6/YQ44iDSvphV1ihdy3W9CuwpjG5hamOV1xwA1HA7Aro5QVgK2K2UancpQp5Jo+RcERdLq5Y7XSRiZ8f1UvnZ22wp5W2ljGMhyvgNo20UQn/92qrnQU17pKwneIJiBGUNqvr+LkQ/NRz62ixXWDrIfAXBKSvA3m/AE0NIw4FJLZk8iPTxR3qPvFb3eMe2dlOqeQjUo40VySzei4xLwmuAh+AvlLy6Ejoe7rvcVbpWdCbsQSldkmEzsu9FstKmfRr2brpbJ8Fg+i1GJJXhrs7OwjMy+B/OfoYWaXqjD5h1P/XsDdPvpLjbVlemx3jbUR37/RAHyEvV/uau/cjb3lPGAsGuHHz9p4wkQ1c6F3NleZnwHpQ9dFm1Uebqo82YxQ0xIbZE9p0csbVYv8AnmGHerVutGQAAAAASUVORK5CYII=" alt="">
          <span>{{ item.recharge_amount }}</span>
        </div>
      </div>
      <div class="invesr_service">
        <div class="appservice">APP服務</div>
        <div class="service_list">
          <a href="#/m/home/Upgrade/index" class="service_item">
            <img src="data:image/png;base64,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" alt="">
            <span>{{ $t('user.upgrade') }}</span>
          </a>
          <a href="#/m/home/gift/list" class="service_item">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAI6klEQVR4Xu2dC2xUxxVAz31rTPwhrQifKoRA+IZKoFKFpkWtCqUE28SAbRaDwUAKdVBCfioFIjUVaiolbakiPomA2gQwMZiNP8HCxlAX+hFpSlRUkFoIEH4hagmgFDAfY++t3i42GK937d33ntdbj2RZ2n1z750z896buffOrNCBRfPyelEnoxEZjurjqAzHoB/KQyiJCMlAHXAN+NL3X7mA6DFEjqJ6jHg9JBs2XOyoZoiTijUvL5E6mQD8AGQ8MAqI1AYFDoPuA/5AvNbIhg3XnWpXpMaHtFNXrDA4+e+JGN75IOlAUshKkV1QC1qB19jE4K/tlRUrvJGJC17bNoDqfi6ZB+oXIrwEDLSzEUFkn0ZZxc24fPG8Yz4GLC+WA1T3Kwkk1C4GlgK9LLc4PIEXUX7DzaQ14nnrRngiAteyFKDm/ngm8CvgUSuNtFDWWWCZFP5uu1UyLQGoOQsG4JJ1IClWGWaznGoavM9KUcGZSPVEDFBnL5yDyNugD0ZqjLP15Qqqz8t7+Vsj0Rs2QJ0//wFuu94GfhSJAR1eV/Vd4r3PyaZNN8OxJSyAmruoD97b5cB3wlEahXU+xOg2TQrXXWivbe0GqLkLH6NB94IObq+y6L5eTuKSiVKYf6o9drYLoGYvHIHh/T3wcHuUdKJrP8dr/FCK8//VVpvbDFDnLBhCg9dcLj3SVuGd9LrPcBnjZWvBibbY3yaA6n6mNy4OAEPaIjQGrjlBA2PF8+4XodoSEqC63fG4kv4EPBlKWIx9/xH/7fF9qVpzK1i7QgPMnpcPLIgxOG1tToEUb14YNkCdMXcOSGFbtcXmdZorO7a0OtludQRqZs4A4uIOA51shWF5N16hvn6UlBYFXPa1DtA9dzcwyXJzOqfAavFsCbjODwhQp+fORNjWOdtqk9WiObJjawsmLQBqel4i3W+YE8lodUnZRCik2LPcShghFc3DBS0BTs9dCmr69LpKCwKyTN4v/PW9HzcDqG53Mg3dTyFR40mOtk68hHFroHg8TeGB5gAzZ7+AsDrarI4qe5QXpfS9NY02NQH0Rc8OHzfXf49FlcHRZ8xpRg0d3BjtuwswK2cSijl16SqhCKimStk2H6u7ADNyzFe0GRRytvTuBTluGPNNSEiA85/D7hrYvRe8d0K6hgEpEyFlAvR7GG7cgIN/hyIPfNEBSQlKsZQX+Vj5AGp6eiLdki+gtge9m3dO/0fg9dfgwR4tO+0vH8Jba/2fv7IYvhvA+X3lKrz2Opz7zNlOF2q5FtdX9hTW+gFOmzUNKHPUChFY+UsYFOSRu3qd36QXF7Vu2qenYMnPQM0MD0dLhpRvK/cDzMheh8qzjqofPhTe/EVwlSc+9X8/ZFDw65b/HI4dd9R8RNdLWfGiOyNw5icoQ221oFs3GP896NnzLpQnRgdX2TiqzNEarHx8CBphX74M+/4Mt2/b2hyE41K+fZhoRm4fvHX/sVcb8OoSePIJ29X4FHz0Mbyx0n5dRnxf0SmzUsBbZbu2siIw36ZOFPPtnZFjvyYlTXRq9nKUN2zX9oFl6ShtM3WqAzMy4VXR9Ox8UPtd9juL29Zwq66akm2VpCBypEA0fUaNP2PU5hKLAJV9oulu0/f3uM34YO1v4dH+tqvxKTh7Dhb/xAldR0Wfdptv4D62azPhzcsBc+k2oL/1LxTzxXHmnH9pt7nID9H+csEEeAUIsJayUfv2TZCUaK2C2uswc761MkNLuyY6ebrjayCKN9sDMHte6CZbfIUJ0Iy8x1ssN7i4GANo+oMe6gIYFgHzFs46BeLsNoRYGYHCBdG0LDP7YGRY/MOttGOLPc/AGXPDtSjcekdF06bXgNo/kb7XxFgBqOw3R6Dz2VexAhAKTIDLwQFnQiyOQExnQlpGChj2u7NiEaCXyaJPZfQhzrDfoRqLAOu9ff0u/clZx1EH859j4xl4XCpLhvkBpmatR8gL913e7noxAVDXS2XpnaBSatY0xMGwZtFG+IrFia9mjHjWM+3uy7ArKBlSVXInrPlUbhJx183noN27yf32LnnJH6GzspiRuJWrrJQYTFYt9Yl3A+u+2zgtywxaOOEHh+QkePl5+PYYCBWyDIXEDH3+9SCsegeu2rIpPZAFxVJZcje1ww+wA6YzoeBE7ffeVKksuy+5yExv+9uRkx14vkHU4rrPsDN8a+SgFult/ulM5guodCVYBu/Kl6WypOlh2zxDdZw7mQTvacRh/2BnGXvKJW4YA2V/Kym+/jlh5lJEupLMA3Wq6jKpKm09ydwH0MwVbIjv2ubQEuBZXHUjpKKi2alIgTfapGXNAoo6y53ljJ06WypLWzBpfatXatZupGur153O2SOVJQG3vbUOMGXaQAzXP7o2G3IFl/ENqfAEPEshaOaipmXmgmxx5haJVi06VypLW93yG3rDdUe4/KOFpbBRdpUEzVwLDTA1tTuS+Mf/yy3/13uMk/3BD+QJCdA/N3T3xvAecNTp2pGjUDiB1xgrVZ7ID51obIdOcg/B5d0P9OvItjmg+zwNxjip9lh37EkTxMkZI1CjGnAo0c8BXM1VnEO8k2RXmfUH7zRBfGpqf+LiTFfO1x1vnr0K/0l9fYrs+aBdiYVtegbeb7dOcvfE5a0AxtrbJsekH6DBSJdqz+X2agwLoP/FktodI3ElinncZ+ctwlq815dIVVXQA3Zaa2DYAJtu6aczM/DKRuCrnYzil4gskF3vl0Zid8QAfaMxLXMAKmZotHMck6JUow2LZHf56UjgmXUtAdg0Gv1enDej+MQP8xDa5VJZYtmRLpYC9I1GtzuBaw3m2Qs/BYmSY5D1ImKsJFFWi8cTvccg33s76JQpPWiIW4BKxx7ELboKV32B7Nx5NdLbNVB9y0dgiymPGe07eGQiXp2POHQUvGoFhmxizMjOexR8oN7yhQvq4ycgmD9IYP4YgZlaHGknmts0jgD7UGqIq6u53+1ux8hrlBmp8RHZ5nNSoKNBhyG+7WbD76y1zV0DZppJY6pJLWD+XQLOA8dQjoJ8AnKoLYv+iAwNUvl/6bnNaWOBewgAAAAASUVORK5CYII=" alt="">
            <span>{{ $t('user.virtual_gifts') }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="site">
    </div>
    <div class="money_fixed">
      <div class="money_fixed_left">
        <span>{{ $t('pay.total_price') }}</span>
        <span>$</span>
        <span>{{ total_price }}</span>
      </div>
      <div class="money_fixed_right" @click="submitBtn">{{ $t('user.recharge') }}</div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {golds} from "@/api/pay";

export default {
  name: "m_pay",
  data(){
    return {
      list: [],
      cus_input: 0,
      total_price: 0,
      currentIndex: 0,
    }
  },
  computed: {
    ...mapGetters(['getUserinfo']),
    balance(){
      return this.getUserinfo ? this.getUserinfo.balance : 0
    },
  },
  created() {
    golds().then(res => {
      if(res.code == 0){
        this.list = res.list
      }
    })
  },
  methods: {
    select(item){
      this.currentIndex = item.id
      this.total_price = item.recharge_amount
    },
    submitBtn(){
      let data = {
        type: 'Recharge',
        id: 0,
        amount: this.total_price
      }
      this.$store.commit('setPayData', data)
      this.$router.push({name: 'MPayPayment'})
    },
  }
}
</script>

<style scoped>
@import "../../assets/css/common.css";
.invest_area{
  width: 100%;
  height: 200px;
  background: url(../../assets/img/chang_subscribe.png) no-repeat;
  background-size: 100% 100%;
  padding: 20px;
  color: #fff;
  position: relative;
}
.invest_area_top{
  text-align: center;
  font-size: 18px;
  height: 20px;
  line-height: 20px;
}
.invest_area_top_icon{
  position: absolute;
  height: 20px;
  left: 20px;
  top: 20px;
  display: flex;
  align-items: center;
}
.invest_area_top_icon{
  position: absolute;
  height: 20px;
  left: 20px;
  top: 20px;
  display: flex;
  align-items: center;
}
.invest_area_top_icon img:first-of-type {
  width: 20px;
  height: 16px;
  margin-right: 15px;
}
.invest_area_top_icon img:nth-of-type(2) {
  width: 25px!important;
  height: 25px!important;
  top: 10px;
}
.invest_num{
  margin: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
}
.invest_num span{
  display: block;
  text-align: center;
}
.num{
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 5px;
}
.num_txt{
  font-size: 16px;
}
.invest_content{
  background: #fff;
  padding: 20px;
}
.invest_content_title{
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  color: #ff4a53;
  font-size: 18px;
  line-height: 20px;
}
.invest_content_title div{
  width: 40px;
  height: 2px;
  background: #ff4a53;
  display: inline-block;
}
.invest_content_title span{
  font-size: 14px;
  padding: 0 10px;
}
.invest_list{
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.invest_item{
  width: calc(50% - 10px);
  background: #fff;
  border: 1px solid #bfc2cc;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 20px;
  color: #bfc2cc;
  font-size: 26px;
  margin-right: 20px;
  margin-top: 20px;
}
.invest_item img{
  width: 30px;
  margin-right: 10px;
}
.invest_item .input{
  border: 1px solid #bfc2cc;
  outline: none;
  font-size: 18px;
  width: 80px;
  height: 30px;
  border-radius: 4px;
}
.invest_item_choose{
  background: #fff8f8;
  border: 1px solid #ff4a53;
  color: #ff4a53;
}
.invesr_service{
  margin-top: 40px;
}
.appservice{
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 16px;
}
.service_list{
  width: 100%;
  display: flex;
}

.service_item{
  margin-right: 50px;
  display: flex;
  flex-direction: column;
}
.service_item img{
  width: 40px;
  height: 40px;
  display: inline;
}
.service_item span{
  font-size: 14px;
  color: #606266;
  text-align: center;
  margin-top: 10px;
}
.site{
  width: 100%;
  height: 60px;
}
.money_fixed{
  width: 100%;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 60px;
  display: flex;
  z-index: 1000;
}
.money_fixed_left{
  flex-shrink: 1;
  width: 100%;
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  display: flex;
}
.money_fixed_left span:first-of-type {
  font-size: 14px;
  color: #303133;
}
.money_fixed_left span:nth-of-type(2), .money_fixed_left span:nth-of-type(3) {
  font-size: 18px;
  color: #ff4a53;
  margin-left: 4px;
}
.money_fixed_right{
  flex-shrink: 0;
  width: 130px;
  height: 61px;
  background: #ff4a53;
  font-size: 18px;
  font-weight: 100;
  border: 0;
  color: #fff;
  text-align: center;
  line-height: 60px;
}
.invest_item:nth-child(2n) {
  margin-right: 0;
}
</style>
